import api from './api'

export const getNubankEmployees = async (email) => {
	try {
		const response = await api.get(`/documents/nubank/employee`, {
			params: { email },
		})

		return response.data
	} catch (error) {
		console.error('ERRO ao buscar dados do Nubank', error)
		throw error
	}
}
